import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

export const buscarMotivosSilenciamentoProduto = async () => {
  const {data, status} = await api.get('get_motivos', {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.motivos;
  }

  logout();
}

export const salvarSilenciamentoProdutos = async (params) => {
  const uri = 'compras/produtos/notificacao-blacklist';
  const {data, status} = await api.post(uri, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.CREATED) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const buscarQtdeProdutosSilenciados = async (params) => {
  const uri = 'compras/produtos/notificacao-blacklist/quantidade';
  const {data, status} = await api.post(uri, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.quantidade;
  }

  logout();
}

export const buscarProdutosSilenciados = async (params) => {
  const uri = 'compras/produtos/notificacao-blacklist/produtos';
  const {data, status} = await api.post(uri, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.produtos;
  }

  logout();
}

export const excluirProdutosSilenciados = async (params) => {
  const uri = 'compras/produtos/notificacao-blacklist/produtos/exclusao';
  const {data, status} = await api.post(uri, params, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}
